<div class="ot-row">
  <div class="otsc-prop-header">
    <h1 class="otsc-prop-header-text" i18n>Agents</h1>
  </div>
</div>
<div style="height: calc(100vh - 160px);">
  <ng-scrollbar #scrollbarRef>
    <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-2">
      <div id="otsc-settings-agents">
        <div class="otsc-settings-label otsc-settings-label-desc" i18n>
          In order to manage your environment, you need to install the Agent on each system hosting OpenText products.
        </div>
        <div class="otsc-settings-label otsc-settings-label-desc" i18n>
          Agents are available for the following platforms:
        </div>
        <div class="ot-row">
          <ul class="ot-list ot-list--is-low-density ot-col ot-row__column">
            @for (instruction of instructions; track instruction; let i = $index) {
            <li tabindex="-1" style="height: auto;" class="ot-list__item">
              <div class="ot-list__item--is-body ot--is-marginless" [id]="'otsc-agent-itembody-' + instruction.id">
                <div class="ot-level">
                  <div class="ot-level__left w-100">
                    <span class="ot-list__icon">
                      <img alt="Microsoft Windows" i18n-alt [attr.src]="instruction.logoSrc">
                    </span>
                    <span class="w-100" i18n>{{instruction.title}}</span>
                  </div>
                </div>
                <div class="instructions">
                  <div class="ot-level ot-mb-1">
                    <div class="ot-level__item">
                      <b class="w-100" i18n>Installation Instructions</b>
                    </div>
                  </div>
                  <div class="ot-level ot-mb-1">
                    <div class="ot-level__item" i18n>{{instruction.description}}</div>
                  </div>
                  <div class="ot-level ot-mb-1">
                    <div class="ot-level__item w-100">
                      <pre class="code-display">
                          <code [id]="instruction.id" #code>{{instruction.codeSnippet}}</code>
                          <img [id]="instruction.id + '-copy-btn'" class="copyIcon" src="./assets/icons/toolbar_copy.svg" alt="Copy to clipboard" i18n-alt title="Copy to clipboard" i18n-title (click)="copyCodeSnippet(code)" />
                        </pre>
                    </div>
                  </div>
                  <div class="ot-level ot-mb-1">
                    <div class="download-text-area">
                      <div class="ot-level__item ot--is-inline-flex" i18n>or download</div><a
                        [id]="instruction.downloadId" class="downloadLink" style="height: unset; padding: 0 5px;"
                        [href]="instruction.downloadLink">{{instruction.downloadName}}</a>
                      <div>{{instruction.downloadInstruction}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </ng-scrollbar>
</div>